import { Modal } from 'antd';
import { BaseModalProps } from 'modules/common/types';
import { RoutineTestForm } from 'modules/donor/components/RoutineTestForm';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  donorId?: string;
} & BaseModalProps;

const RoutineTestModal: FC<Props> = ({
  hide,
  onCancel,
  onOk,
  donorId,
  visible,
  ...restProps
}) => {
  const { t } = useTranslation('donor.RoutineTestModal');
  const routineTestFormRef = useRef(null);

  const [isFormValid, setIsFormValid] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);

  useEffect(() => {
    if (!visible) {
      setIsFormValid(false);
      setIsFormDirty(false);
    }
  }, [visible]);

  const closeImmediately = (e?: any) => {
    hide();
    onCancel && onCancel(e);
  };

  const onCancelHandler = (e: any) => {
    if (!isFormDirty) {
      closeImmediately(e);
      return;
    }

    e?.persist?.();

    Modal.confirm({
      title: t('unsavedChangesTitle'),
      content: t('unsavedChangesMessage'),
      okText: t('discardChanges'),
      cancelText: t('stayOnPage'),
      onOk: () => closeImmediately(e),
    });
  };

  const onOkHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const current = routineTestFormRef?.current as any;
    current.createAndPrintHandler();
    onOk && onOk(e);
  };

  return (
    <Modal
      onCancel={onCancelHandler}
      onOk={onOkHandler}
      okButtonProps={{
        disabled: !isFormValid,
      }}
      cancelText={t('close')}
      maskClosable={false}
      visible={visible}
      title={t('title')}
      destroyOnClose
      {...restProps}
    >
      <RoutineTestForm
        donorId={donorId}
        ref={routineTestFormRef}
        hide={hide}
        setIsFormValid={setIsFormValid}
        setIsFormDirty={setIsFormDirty}
      />
    </Modal>
  );
};

export default RoutineTestModal;
